/**
* Variables de entorno tipadas. Cargadas desde Vite (prefix VITE_).
*
* Falla fuerte al inicio si falta algo crítico — preferimos error en build
* que un undefined silencioso en runtime.
*/
function required(name: string, value: string | undefined): string {
  if (!value || value.trim() === "") {
    throw new Error(`Falta variable de entorno: ${name}`);
  }
  return value;
}

function optional(value: string | undefined): string | null {
  if (!value || value.trim() === "") return null;
  return value;
}

export const ENV = {
  SUPABASE_URL: required(
    "VITE_SUPABASE_URL",
    import.meta.env.VITE_SUPABASE_URL,
  ),
  SUPABASE_ANON_KEY: required(
    "VITE_SUPABASE_ANON_KEY",
    import.meta.env.VITE_SUPABASE_ANON_KEY,
  ),
  API_BASE_URL: required(
    "VITE_API_BASE_URL",
    import.meta.env.VITE_API_BASE_URL,
  ),
  PADDLE_ENV: (import.meta.env.VITE_PADDLE_ENV ?? "sandbox") as
    | "sandbox"
    | "production",
  PADDLE_CLIENT_TOKEN: optional(import.meta.env.VITE_PADDLE_CLIENT_TOKEN),
  PADDLE_PRICES: {
    "pro:monthly": optional(import.meta.env.VITE_PADDLE_PRICE_PRO_MONTHLY),
    "pro:yearly": optional(import.meta.env.VITE_PADDLE_PRICE_PRO_YEARLY),
    "plus:monthly": optional(import.meta.env.VITE_PADDLE_PRICE_PLUS_MONTHLY),
    "plus:yearly": optional(import.meta.env.VITE_PADDLE_PRICE_PLUS_YEARLY),
  } as Record<string, string | null>,
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
} as const;
